export default __webpack_public_path__ + "static/media/W_Wasai.ed89ace6.mp3";